export default __webpack_public_path__ + "static/media/LifeLock-logo.46e90b6d.png";